import React, { Component } from 'react'
import DashboardHeaderUi from '../../presentational/DashboardLayout/Header.component'
import LocalStore from '../../../utils/localStorageUtil'

class DashboardHeader extends Component {
    constructor(props) {
        super(props);
        this.state = {
            userName: LocalStore.getFromLocalStorage('adminUserName')
        }
    }

    render() {
        return (
            <div>
                <DashboardHeaderUi
                    logoutHandler={this.logoutHandler.bind(this)}
                    userName={this.state.userName}
                />
            </div>
        )
    }

    logoutHandler() {
        this.props.logoutHandler()
    }

}

export default DashboardHeader;